var React = require('react');

function ThumbsUpLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 45.49H1a1 1 0 110-2h4a1 1 0 001-1v-24a1 1 0 00-1-1H1a1 1 0 110-2h4a3 3 0 013 3v24a3 3 0 01-3 3z","key":0}),React.createElement("path",{"d":"M27.14 46c-6.63 0-8.78-.62-20.6-6.62a1 1 0 01.91-1.78c12.77 6.48 13.48 6.47 22.21 6.38h3.87c4.21 0 6.82-2.37 8.48-7.66a.502.502 0 010-.12l3.79-12.72v-.1a3 3 0 00-2-3.74 2.704 2.704 0 00-.85-.13H33.2a5 5 0 01-5-5 4.907 4.907 0 01.16-1.27l1.77-6.7a2.44 2.44 0 00-.25-1.83 2.43 2.43 0 00-4.09-.17l-9.78 13.85a5 5 0 01-4.08 2.12H7a1 1 0 110-2h4.93a3 3 0 002.45-1.27l9.78-13.85a4.42 4.42 0 017.436.307 4.43 4.43 0 01.464 3.353l-1.76 6.69a3 3 0 002.9 3.77H43c.484 0 .966.071 1.43.21a5 5 0 013.36 6.15v.11L44 36.69a.514.514 0 010 .13c-1.9 6.16-5.31 9.16-10.42 9.16h-3.85l-2.59.02z","key":1})]);
}

ThumbsUpLight.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = ThumbsUpLight;

ThumbsUpLight.default = ThumbsUpLight;
